import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { FlyoutTitle } from '../../../../components/flyout-components/FlyoutTitle';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { StatusCode } from '../../../../utils/api';
import { DealerRead } from '../../../../support/models/dealers/dealer-read';
import { DealerEditBasicInfo } from './DealerEditBasicInfo';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';

interface IProps {
    visible: boolean;
    onSuccess: any;
    onClose: any;
    dealer: DealerRead;
    addresses: ShipToAddressRead[];
}

export const ActionEditDealerInfo = (props: IProps) => {

    const [service] = React.useState(new DealerSvc());
    const [editDealer, setEditDealer] = React.useState<DealerRead>(new DealerRead());
    const [availableAddresses, setAvailableAddresses] = React.useState<ShipToAddressRead[]>([]);

    React.useEffect(() => {
        if (props.visible) {

            const tmpDealer = { ...props.dealer };
            setEditDealer(tmpDealer);

            var availAddresses = props.addresses.filter(a => !a.isJobSite);
            setAvailableAddresses(availAddresses);
        }
    }, [props.visible]);

    /**
     * Save the changes to the dealer before closing
     */
    const onSaveInfo = async () => {

        if (editDealer) {
            const result = await service.saveDealer(editDealer);
            if (result.status === StatusCode.Success) {
                setEditDealer(undefined as unknown as DealerRead);
                props.onSuccess(result.data);
            }
        }
    };

    /**
     * Cleanup some our state and close the panel
     */
    const onClose = () => {
        setEditDealer(undefined as unknown as DealerRead);
        props.onClose();
    };

    const handleOnChange = (newDealer: DealerRead) => {
        if (newDealer) {
            setEditDealer({ ...newDealer });
        }
    };

    return editDealer
        ? <Drawer
            anchor="right"
            onClose={onClose}
            open={props.visible}>
            <div className="stop-action-drawer mini stop-action-basic-info">

                <FlyoutTitle
                    onMobileClose={onClose}
                    title={"Update Dealer"} />

                <DealerEditBasicInfo
                    dealer={editDealer}
                    onDealerChange={handleOnChange}
                    addresses={availableAddresses}
                />

                <FlyoutSaveCancel
                    onSave={onSaveInfo}
                    onCancel={onClose}
                />

            </div>
        </Drawer>
        : null;
};
